export default __webpack_public_path__ + "static/B0051-353d5808e31fe80fe86690a4a8a7df1c.png";